const PublicFieldErrorMessage = ({ errors, id }) => {
  if (!errors || (Array.isArray(errors) && errors.length === 0)) return null

  const errorList = typeof errors === "string" ? [errors] : errors

  return (
    <div id={id} className="text-danger" role="alert" aria-live="assertive">
      {errorList.map((error, index) => (
        <p key={index} className="error">
          {error}
        </p>
      ))}
    </div>
  )
}

export default PublicFieldErrorMessage
